
define('text!modules/reporting/campaigns/performance/templates/performance.html',[],function () { return '<div class="w-panel-body w-performance-panel"></div>\n';});

